export default {
  common: {
    adminFunction: "Administrationsfunktion",
    ecatLibrary: "e-CAT Bibliothek",
    accountManagement: "Kontoverwaltung",
    accountPermission: "Verwaltung von Konten & Berechtigungen",
    regionManagement: "Regionalverwaltung",
    zoneCountryCity: "Gebiet, Land und Stadt aktualisieren",
    cityWeatherManagement: "Stadtwetterdaten",
    weatherProfileBaseOnCity: "Wetterprofil anhand der Stadt aktualisieren",
    ecatDataManagement: "e-CAT Datenverwaltung",
    digitalEcatLibrary: "Digitale e-CAT-Bibliothek",
    ecatLibraryEquipmentsModels: "Geräte und Modelle der e-CAT-Bibliothek",
    cancel: "Abbrechen",
    save: "Speichern",
    permission: "Berechtigung",
    noAccountInfo: "Keine Kontoinformationen",

    customerFeedback: "Kundenfeedback",
    viewFeedbackList: "Benutzerrückmeldung",

    unitSetting: "Einstellung der Maßeinheiten",
    globalUnitPreferences: "Globale Einheitenpräferenzen",

    usefulTools: "Nützliche Werkzeuge",
    efficiency: "Effizienz"
  },
  account: {
    inputUserName: "E-Mail eingeben",
    thereAreNoMoreUsersLeft: "Es sind keine weiteren Benutzer vorhanden.",
    superAdmin: "Superadministrator",
    global: "Global",
    region: "Region",
    regional: "Regional",
    zoneCountry: "Gebiet/Land",
    city: "Stadt",
    segmentMegaCity: "Segment (Megastadt)",
    status: "Status",
    activeStatus: "Betriebsmodus",
    role: "Rolle",
    active: "Aktiv",
    inactive: "Inaktiv",
    fillRole: "Bitte wählen Sie eine Rolle",

    multiRegional: "Regionsübergreifend",
    multiZoneCountry: "Mehrere Gebiete/Länder",
    singleZoneCountry: "Einzelnes Gebiet/Land",

    otherRegions: "andere Regionen",
    otherZones: "andere Gebiete"
  },
  feedback: {
    yourOpinionImportant: "Ihre Meinung ist sehr wichtig",
    tellYourExperience: "Bitte schildern Sie uns Ihre Benutzererfahrung",
    detailedFeedback: "Bitte geben Sie Ihr Feedback ein:",
    provideDetailedYourOpinionssuggestions:
      "Bitte geben Sie eine detaillierte Beschreibung Ihrer Anmerkungen und Vorschläge. Sie können diese Seite erneut von [Mein Bereich] -> [Mein Feedback] öffnen.",
    submitFeedback: "Rückmeldung absenden",
    localAdministrator: "Lokaler Support",
    ifProblemsContact: "Wenn Sie dringende Probleme haben, kontaktieren Sie bitte",
    noFeedback: "Kein Feedback",
    submissionSuccessful: "Übermittlung erfolgreich",
    myFeedback: "Mein Feedback",
    thereAreNoMoreFeedbackLeft: "Es gibt kein weiteres Feedback mehr."
  },
  digitalEcat: {
    publicEcatLib: "e-CAT Bibliothek",
    myCustomized: "Benutzerbibliothek",
    chillerCapacity: "Kälteleistung des Flüssigkeitskühlers",
    thereNoEcatLeft: "Es sind keine weiteren e-CAT-Daten vorhanden",
    capacityRange: "Leistungsbereich",
    compressorType: "Verdichtertyp",
    refrigerantType: "Kältemitteltyp",
    pleaseSelectOrEnter: "Modell suchen oder Filterkriterien auswählen",
    clickHereToSelectAJsonFile: "Klicken Sie hier, um eine JSON-Datei auszuwählen",
    successfullyParsed: "{modelsCount} Modelle erfolgreich eingelesen",
    bearingType: "Lagertyp",
    manufacturingRegion: "Produktionsregion",
    me: "ich",
    libraryOwner: "Bibliotheksbesitzer",
    addSelfChillerModel: "Eigenes Flüssigkeitskühlermodell hinzufügen",
    capacity: "Leistung",
    designCondenserTemp: "Designtemperatur Kondensator",
    eCatPerformanceData: "e-CAT Leistungsdaten",
    point4Data: "4-Punkt-Daten",
    point10Data: "10-Punkt-Daten",
    computerPreview: "Vorschau der Leistungskennlinie",
    previewChilledWaterTemp: "Vorschau der Kaltwassereintrittstemperatur",
    previewCondenserTemp: "Vorschau der Kühlwassereintrittstemperatur am Verflüssiger",
    previewCondenserAirTemp: "Vorschau der Lufteintrittstemperatur am Verflüssiger",
    compute: "Berechnen",
    chillerType: "Flüssigkeitskühlertyp",
    youAreCurrentlyUsingLibrary: "Sie verwenden derzeit die Bibliothek von '{selectUserEmail}' und sind nicht berechtigt, diese zu ändern und zu speichern.",

    chillerModel: "Flüssigkeitskühlermodell",
    modelNumber: "Modellnummer",
    objective: "Zielsetzung",
    heatpumpType: "Wärmepumpentyp",
    heatpumpFileParsed: "Wärmepumpendatei erfolgreich verarbeitet",
    chillerFileParsed: "Kältemaschinendatei erfolgreich verarbeitet",

    previewSourceWaterTemp: "Vorschau der Wassereintrittstemperatur auf der Quellenseite",
    previewSourceAirTemp: "Vorschau der Lufteintrittstemperatur auf der Quellenseite",
    previewHotWaterTemp: "Vorschau der Heizwasservorlauftemperatur",

    deviceType: "Gerätetyp",
    addSelfHeatPumpModel: "Eigenes Wärmepumpenmodell hinzufügen",
    heatPumpModel: "Wärmepumpenmodell",
    selectEquipmentType: "Gerätetyp auswählen",
    createACustomChillerModel: "Benutzerdefiniertes Flüssigkeitskühlermodell erstellen",
    createACustomHeatPumpModel: "Benutzerdefiniertes Wärmepumpenmodell erstellen"
  },
  usefulTools: {
    asseesConfig: "Bewerten Sie die Vorteile einer Umrüstung der Ventilatoren der Lüftungsanlage auf Direktantriebe.",
    clickEnter: "Zur Eingabe hier klicken",
    integratesTools: "Diese Plattform integriert alle Upgrade- und Retrofit-Tools"
  }
}



// WEBPACK FOOTER //
// ./src/locale/admin/de.js